// hooks/useUser.ts
import { useContext } from "react";
import { UserInterface } from "../interfaces";
import { UserContext } from "../context";

interface UseUserReturn {
  user: UserInterface | null;
  setUser: (user: UserInterface) => void;
  clearUser: () => void;
}

export const useUser = (): UseUserReturn => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }

  const { state, dispatch } = context;

  const setUser = (user: UserInterface) => {
    dispatch({ type: "SET_USER", payload: user });
  };

  const clearUser = () => {
    dispatch({ type: "CLEAR_USER" });
  };

  return {
    user: state.user,
    setUser,
    clearUser,
  };
};
